import {Matcher} from '@/lib/axiosAddTransforms'
import {certStatusDict, dateResponse, restDateResponse} from '@/transformers/utils'
import {certificateResponse} from '@/transformers/matchers/certificates'

const matchers: Matcher[] = [
  {
    test: /^\/institutions\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/3rd-party-services/summary`
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return institutionsResponse(data)
      },
    },
  },
  {
    test: /^\/institutions\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, type, code} = payload.data
        if(code) {
          payload.url = `/bizs/${bizId}/3rd-party-services/${type}/${code}`
        } else {
          payload.url = `/bizs/${bizId}/3rd-party-services/${type}`
        }
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return institutionResponse(data, null)
      },
    },
  },
  {
    test: /^\/failed-institution\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, type, name} = payload.data
        const path = type === 'bank' ? `bank/${name}` : type
        payload.url = `/bizs/${bizId}/3rd-party-services/${path}/acc-certs`
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return {}
        }
        const results = data.results.map((result) => failedInstitutionsResponse(result))
        return {
          results: results.filter((result) => {
            return result.status === 'failure' ||
              result.status === 'pending'||
              result.status === 'expired'
          }),
        }
      },
    },
  },
  {
    test: /^\/institution\/\$id\/?$/,
    method: 'patch',
    transform: {
      request: (payload) => {
        const {bizId, type, name} = payload.params
        const path = type === 'bank' ? `bank/${name}` : type
        payload.url = `/bizs/${bizId}/3rd-party-services/${path}`
        delete payload.params.bizId
        delete payload.params.type
        delete payload.params.name
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return data
      },
    },
  },
]

export const institutionsResponse = (data) => {
  const banks = data?.bank?.map((result) => bankResponse(result)) || []
  return [
    institutionResponse(data.hometax, 'hometax'),
    institutionResponse(data.popbill, 'popbill'),
    institutionResponse(data.giro, 'giro'),
    institutionResponse(data.ei, 'ei'),
    ...banks
  ]
}

export const institutionResponse = (data, name) => {
  if(data) {
    const {id, status, accreditedCertificate, errorCode} = data
    const {
      isAvailable = true, id: certId, orgNm, certNm, endDate = null
    } = accreditedCertificate || {}
    return {
      id: String(id),
      status: statusResponse(status, isAvailable),
      certId: String(certId),
      type: name,
      name,
      errorMessage: errorCode,
      agency: orgNm,
      certNumber: certNm,
      endDate: dateResponse(endDate),
      restExpiryDate: restDateResponse(dateResponse(endDate)),
    }
  }
  return {id: null, status: 'pending', type: name, name}
}

export const bankResponse = (data) => {
  if(data) {
    const {bankCode} = data
    return {
      ...institutionResponse(data, 'bank'),
      bankCode,
      name: bankCode,
    }
  }
}

const failedInstitutionsResponse = (data) => {
  if(data) {
    const {result, isAvailable} = data
    return {
      ...certificateResponse(data),
      status: failedInstitutionStatus(result, isAvailable),
      errorCode: result ? result.errorCode : null,
      verificationMessage: result ? result.verificationMessage : '',
    }
  }
}

export const failedInstitutionStatus = (result, isAvailable) => {
  if(result) {
    const {status} = result
    return statusResponse(status, isAvailable)
  }
  return 'pending'
}

export const statusResponse = (status, isAvailable) => {
  if(!isAvailable) {
    return 'expired'
  }
  return certStatusDict[status]
}

export default matchers
